// extracted by mini-css-extract-plugin
module.exports = {"main":"RbbTtsTemplate_main__1-xN1"};